import { render, staticRenderFns } from "./QuoteCreate.vue?vue&type=template&id=2616a52f&scoped=true"
import script from "./QuoteCreate.vue?vue&type=script&lang=js"
export * from "./QuoteCreate.vue?vue&type=script&lang=js"
import style0 from "./QuoteCreate.vue?vue&type=style&index=0&id=2616a52f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616a52f",
  null
  
)

export default component.exports